import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';


class SectionLabel extends React.PureComponent {
  static propTypes = {
      showSectionPartPrefix: PropTypes.bool.isRequired,
      sectionNumber: PropTypes.number.isRequired,
      allAttempted: PropTypes.bool.isRequired,
      isCurrentSection: PropTypes.bool,
      attempted: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
      isCSCBSection: PropTypes.bool,
  };

  render() {
      const { showSectionPartPrefix, sectionNumber, allAttempted, isCurrentSection, attempted, total, isCSCBSection } = this.props;
      const accessibleButtonTextPrefix = `${
          showSectionPartPrefix
              ? t('generic.sectionPartPrefix')
              : t('generic.sectionNumberPrefix')} 
            ${sectionNumber}.`;

      return (
          <span>
              {
                  allAttempted ? <i className="fa fa-check" /> : null
              }
              { showSectionPartPrefix
                  ? <span aria-hidden="true" className="section-prefix">{t('generic.sectionPartPrefix')} </span>
                  : null
              }
              <span className="sectionNr" aria-hidden="true">{ sectionNumber }</span>
              {
                  !isCSCBSection && (
                      !isCurrentSection && !allAttempted ?
                          (<React.Fragment>
                              <span className="attemptedCount" aria-hidden="true">
                                  { t('footer.numberOfItemsAttempted', { attempted, total }) }
                              </span>
                              <span className="sr-only">
                                  { t('footer.numberOfItemsAttemptedSROnly', { accessibleButtonTextPrefix, attempted, total }) }
                              </span>
                          </React.Fragment>) : null)
              }
              {
                  !isCurrentSection && allAttempted && (
                      <span className="sr-only">
                          { t('footer.allItemsAttemptedSROnly', { accessibleButtonTextPrefix }) }
                      </span>
                  )
              }
          </span>
      );
  }
}

export default SectionLabel;
